import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BaseService, LayoutService } from '../../services';
import { I18Service } from '../../services/i18Service';
import { AlertsService } from '../../services/alerts.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss']
})
export class UploadDocumentComponent implements OnInit {
  @Input() headerUpload = false;
  lang = this.baseService.currentLang || localStorage.getItem('lang') || 'ar';
  fileName: string = null;
  private subscriptions: Subscription[] = [];
  fileForm: FormGroup;
  constructor(
    private translate: TranslateService,
    private clipboard: Clipboard,

    private i18Service: I18Service, private alertService: AlertsService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder, public layoutService: LayoutService,
    private baseService: BaseService) {

      this.translate.use( this.lang);

  }


  ngOnInit(): void {
    let subscription = this.i18Service.getLocalEvent()
      .subscribe(local => this.translate.use(local))
    this.subscriptions.push(subscription);



    this.fileForm = this.fb.group({
      referenceId: [''],
      UrlBase64: ['']


    });
    this.baseService.getLangData().subscribe(data => {
      this.changeLagView(data.lang);

     });

  }
  changeLagView(lang){
   this.lang = lang;
    this.translate.use(this.lang);

  }


  Upload(image: any) {
    this.converted = false;
    const reader = new FileReader();
    this.fileName = null;
    if (image) {
      reader.readAsDataURL(image.target.files[0]);
      this.url = '';
      this.fileName = image.target.files[0].name;
      reader.onloadend = () => {
        var base64data = reader.result;
        this.fileBase64 = base64data;
        this.converted = true;

      }
    }
  }

  converted = false;
  fileBase64;
  url = "";
  // SaveEditorFile() {
  //   const controls = this.fileForm.controls;
  //   Object.keys(controls).forEach(key => {
  //     controls[key].markAsTouched();
  //   });


  //   this.fileForm.patchValue({
  //     referenceId: environment.ReferenceId,
  //     UrlBase64: this.fileBase64

  //   });
  //   if (!this.converted) {
  //     this.alertService.warningGeneralMsg(this.lang, ' يجب اختيار ملف للتحميل', 'The file must be selected to upload')
  //     return;
  //   }
  //   this.spinner.show();
  //   let subscription = this.baseService.post('Documents/SaveEditorDocs', this.fileForm.value).subscribe({
  //     next: (result: any) => {
         
  //       if (result.header.success) {
  //         this.alertService.success(this.lang, result)
  //         this.url = result.output.Url;
  //         this.fileForm.reset();
  //       }
  //       else { this.alertService.error(this.lang, result) }

  //       this.spinner.hide();

  //     },
  //     error: (error: string) => {  ; this.spinner.hide(); }
  //   });
  //   this.subscriptions.push(subscription);



  // }
  copyUrl() {
    this.clipboard.copy(this.url)
  }
}
